import { PermissionName } from '~/graphql/graphql';

import type { RouteRecordRaw } from 'vue-router';

const addressRoutes: RouteRecordRaw[] = [
  {
    name: 'location.overview',
    path: '/locations',
    component: async () => import('~/views/location/Overview.vue'),
    meta: {
      middleware: {
        before: ['auth', 'can'],
      },
      can: [PermissionName.VehiclesViewAll],
    },
  },
];

export default addressRoutes;
